const IMPORT_FIELDS = [
  { key: "streetAddress", label: "Address" },
  { key: "zipCode", label: "ZipCode" },
  { key: "city", label: "City" },
  { key: "phoneNumber", label: "PhoneNumber" },
  { key: "email", label: "Email" },
];

function isBlank(value) {
  return value === null || value === undefined || String(value).trim() === "";
}

export function findClinicsWithMissingData(clinics) {
  return clinics
    .map((clinic) => ({
      clinic,
      missingLabels: IMPORT_FIELDS.filter(({ key }) => isBlank(clinic[key])).map(
        ({ label }) => label,
      ),
    }))
    .filter(({ missingLabels }) => missingLabels.length > 0);
}
